// src/hooks/usePrivyLogin.js
import { useEffect } from "react";
import { usePrivy } from "@privy-io/react-auth";
import { useDispatch, useSelector} from "react-redux";
import { setPrivyUser, setAuthenticated, logoutPrivyUser, setApiKey } from '../store/actions/index';
import { Login } from '../API/index.js';
const usePrivyLogin = () => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.privy.authenticated);
  const { ready, authenticated, user, login, logout } = usePrivy();

  useEffect(() => {
    // 当用户成功登录后，authenticated 将变为 true
    if (ready && authenticated &&!auth) {
      // 发起 GET 请求
      Login().then(res => {
        console.log('res', res);
        if (res.api_key) {
          dispatch(setApiKey(res.api_key));
        }
        dispatch(setAuthenticated(true));
      })
    }
  }, [ready, authenticated,auth]);

  const handleLogin = () => {
     login();
  };
  return {  ready, authenticated, user, handleLogin, logout };
};

export default usePrivyLogin;
